module.exports = __webpack_public_path__ + "static/media/right-menu-home-icon.c6befa23.svg";